import axios from "axios";
import {convertSHA} from "./ExtracurricularCoursesToken"

export const GET_ALL_USERS_ADMIN = "GET_ALL_USERS_ADMIN";
export const GET_USER_ADMIN = "GET_USER_ADMIN";
export const GET_BADGE = "GET_BADGE";
export const GET_ROL = "GET_ROL";
export const LOCAU_LOADING = "LOCAU_LOADING";
export const ADD_USER_ADMIN = "ADD_USER_ADMIN";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL_EXTRACURRICULAR,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    }
});


export const getAllUsers = () => {
  var Token = convertSHA()
  return   async  dispatch =>{
    dispatch({
      type: LOCAU_LOADING
    });
    await instance.get(`/UserMLTAdmin/GetAllMLTAdmin/${Token}1`).then((res => {
        dispatch({
            type: GET_ALL_USERS_ADMIN,
            data: res.data
            });
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetUserById = (id) => {
  var Token = convertSHA()
  return  async  dispatch =>{
    dispatch({
      type: LOCAU_LOADING
    });
    await instance.get(`/UserMLTAdmin/GetMLTAdminById/${id}&${Token}1`).then((res => {
        dispatch({
            type: GET_USER_ADMIN,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const GetUserByBadge = (Badge) => {
  var Token = convertSHA()
  return  async  dispatch =>{
    dispatch({
      type: LOCAU_LOADING
    });
    await instance.get(`/Enrollment/GetNameByBadge/${Badge}&${Token}`).then((res => {
        dispatch({
            type: GET_BADGE,
            data: res.data
            })
      console.log("Resp", res);
      }
      )).catch(function(error){
        console.log("Error", error);
      });
  } 
};

export const addUSer = data =>{
  var Token = convertSHA()
     return async dispatch => {
        dispatch({
            type: LOCAU_LOADING
          });
        console.log(data)
        //axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
        await instance.put(`/UserMLTAdmin/PutInsUpdtMLTAdmin/${data.id}&${data.badge}&${data.fNanme}&${data.active}&${data.modified_By}&${Token}1` ).then((res => {
            dispatch({
                type: ADD_USER_ADMIN,
                data: res.data
                
            });
            console.log(res.data)
        })).catch(function(error){
          console.log("Error", error);
        });
    }
}
